import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NotificationRefreshService {

    private refreshSubject = new Subject<void>();

    refresh$ = this.refreshSubject.asObservable();

    triggerRefresh(): void {
        console.log("Refresh executed");
        this.refreshSubject.next();
    }
}




// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/notificationRefreshService.ts